<template>
  <div class="xl:px-32 lg:px-20 md:px-14 px-10 bg-white">
    <div class="bg-white pt-5 text-center pb-5">
      <h2 class="md:text-3xl sm:text-2xl text-xl font-bold text-[#006] pb-3">
        Regístrate
      </h2>
      <!-- <h3 class="text-black md:text-lg sm:text-base text-smpt-5 text-center">
        Si quieres estar en el PROCESA 2022 deberás completar tu registro
        haciendo click en
        <a
          href="https://forms.gle/bRkZ95FdkJrAv26KA"
          target="blank"
          class="link link-accent text-[#00BFFF]"
          >este formulario</a
        >
        y luego realizar el pago según las tarifas generales presentadas a
        continuación:
      </h3> -->
      <h4 class="text-black md:text-lg sm:text-base text-smpt-5 text-center">
        ¿Te animas a asistir al PROCESA 2022? Entonces, deberás completar los
        siguientes pasos según si eres participante nacional o internacional:
      </h4>
    </div>
    <div class="bg-white pt-5 text-justify pb-5">
      <h3 class="md:text-xl sm:text-lg text-sm font-bold text-black pb-3">
        Nacionales:
      </h3>
      <ol class="pl-4">
        <li class="text-black md:text-base text-sm pb-2">
          <b>1)</b> Completar el formulario de registro al PROCESA 2022, este
          paso es imprescindible (
          <a
            href="https://forms.gle/bRkZ95FdkJrAv26KA"
            target="blank"
            class="link link-accent text-[#00BFFF]"
            >https://forms.gle/bRkZ95FdkJrAv26KA</a
          >).
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>2)</b> Realizar el pago de la inscripción a partir de las
          <b>9:00 am</b> del día siguiente posterior al registro, el pago lo
          podrás realizar a través de la banca móvil, banca por internet o
          ventanilla de los bancos BCP, Interbank, Scotiabank y BBVA.
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>3)</b> Para el caso de banca móvil y banca por internet deberás
          seleccionar “Pago de Servicios”, luego buscar “Utec” y seleccionar
          “Utec Derechos”. Te pedirá ingresar tu N° de DNI con el que te
          registraste en el formulario (Ejemplo:
          <a
            href="https://youtu.be/2gmCaqJXrR8"
            target="blank"
            class="link link-accent text-[#00BFFF]"
            >https://youtu.be/2gmCaqJXrR8</a
          >).
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>4)</b> Para el caso de ventanilla deberás mencionar el pago a Utec
          > Utec Derechos y proporcionar tu N° de DNI con el que te registraste
          en el formulario.
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>5)</b> Enviar el comprobante de pago al e-mail
          <a
            class="text-[15px] md:text-lg sm:text-base text-sm text-[#00BFFF]"
            href="mailto:procesa@utec.edu.pe"
            >procesa@utec.edu.pe</a
          >
          con el asunto “Pago PROCESA 2022” adjuntando tus nombres y apellidos
          (Es importante que se note el código o número de operación).
        </li>
      </ol>
    </div>
    <div class="bg-white pt-5 text-justify pb-5">
      <h3 class="md:text-xl sm:text-lg text-sm font-bold text-black pb-3">
        Internacionales:
      </h3>
      <ol class="pl-4">
        <li class="text-black md:text-base text-sm pb-2">
          <b>1)</b> Completar el formulario de registro al PROCESA 2022, este
          paso es imprescindible (
          <a
            href="https://forms.gle/bRkZ95FdkJrAv26KA"
            target="blank"
            class="link link-accent text-[#00BFFF]"
            >https://forms.gle/bRkZ95FdkJrAv26KA</a
          >).
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>2)</b> Realizar el pago de la inscripción en cualquier banco de tu
          país proporcionando los siguientes datos:
          <div class="flex justify-center pt-2 w-full pb-3">
            <img
              class="shadow-md shadow-[#231f20] rounded-xl border border-[#231f20] w-full"
              src="../../assets/inscripciones/datos_pago.png"
            />
          </div>
          <h3 class="text-black md:text-base text-sm pb-2 text-justify">
            <i
              >(Es importante que realices solo el pago de los 55 dólares
              exactos. En otras palabras: El pago de inscripción + Comisiones
              del banco= 55 dólares)</i
            >
          </h3>
        </li>
        <li class="text-black md:text-base text-sm pb-2">
          <b>3)</b> Enviar el comprobante de pago a
          <a
            class="text-[15px] md:text-lg sm:text-base text-sm text-[#00BFFF]"
            href="mailto:procesa@utec.edu.pe"
            >procesa@utec.edu.pe</a
          >
          con el asunto “Pago PROCESA 2022” adjuntando tus nombres y apellidos
          (Es importante que se note el código o número de operación).
        </li>
      </ol>
    </div>
    <h3 class="md:text-xl sm:text-lg text-sm font-bold text-black pb-3">
      Tarifario:
    </h3>
    <div class="flex justify-center pt-2 w-full pb-10">
      <img
        class="shadow-md shadow-[#231f20] rounded-xl border border-[#231f20] w-full"
        src="../../assets/inscripciones/tarifa.png"
      />
    </div>
    <h3 class="text-black md:text-base text-sm pb-10 text-justify">
      *La comisión por transacción interbancaria en Perú, en caso lo hubiese,
      deberá ser asumida por el participante.<br />
      **La comisión por transacción interbancaria en el extranjero será asumida
      por la organización. Para ello, es importante realizar el pago exacto de
      los 55 dólares. En este pago deberá estar incluido las comisiones que
      cobren los bancos.<br />
      Se puede mostrar por la siguiente fórmula: <br />
      <i>Pago de inscripción + Comisiones= 55 dólares </i> <br />
      Este cálculo deberá ser realizado por cada participante. De no hacerlo, el
      participante asumirá cualquier monto extra a los 55 dólares originales y
      la organización no reembolsará este gasto. <br />
    </h3>

    <h3 class="text-black md:text-base text-sm pb-10 text-justify">
      Por último, debes recordar que el
      <span class="font-bold text-[#006]">
        último día para el pago de inscripción será el 31 de julio.
      </span>
      Y además, de que si se desea recibir una factura a nombre de la
      universidad el pago deberá ser realizado desde una cuenta a tu nombre en
      los bancos desde donde se realiza la transacción.
    </h3>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
